export function layout(graph, node) {
  // 递归处理y坐标
  yAxis(graph, node)
  // 递归处理x坐标
  xAxis(graph, node)
}

// 递归处理y坐标
function yAxis(graph, node) {
  let edges = selfEdges(node) // 子节点
  let num = edges.length // 子节点数量
  // 递归处理y坐标
  for (let edge of edges) {
    // 子节点数量大于1
    graph.update(edge.target.id, {
      x: node.getModel().x,
      y: node.getModel().y + 180
    })
    // 递归调用
    yAxis(graph, edge.target)
  }
}

// 递归处理x坐标
function xAxis(graph, node) {
  let edges = selfEdges(node) // 子节点
  console.log(edges)
  let num = edges.length // 子节点数量
  let offset = 0 - (num * 100) / 2 // 偏移量
  // 如果子节点只有一个或没有则退出
  if (num <= 1) {
    return
  }
  // 递归处理y坐标
  for (let i of edges) {
    let edge = edges[i]
    offset = offset + 100 * i
    graph.update(edge.target.id, {
      x: node.getModel().x + offset
    })
    // 递归调用
    xAxis(graph, edge.target)
  }
}

// 获取自己为起点的连线
function selfEdges(node) {
  let edge = null
  let edges = node.getEdges() // 连线
  let selfEdges = [] // 自己为起点的连线
  for (edge of edges) {
    if (edge.source.id == node.id) {
      selfEdges.push(edge)
    }
  }
  return selfEdges
}

/**
 * 转换为二维数组
 * @param nodes
 * @param parentId
 * @returns {Array}
 */
export function toArray(nodes, parentId = '') {
  if (!nodes) return []
  var childKey = 'children'
  var r = []
  if (nodes instanceof Array) {
    for (var item of nodes) {
      var node = {}
      for (var key in item) {
        if (key != childKey) {
          node[key] = item[key]
        }
      }

      node['parent'] = parentId

      r.push(node)
      if (item[childKey]) {
        r = r.concat(toArray(item[childKey], item.id))
      }
    }
  } else {
    r.push(nodes)
    if (nodes[childKey]) {
      r = r.concat(toArray(nodes[childKey]))
    }
  }
  return r
}

/**
 * 转换为树状结构
 * @param data
 * @param parent_id
 * @returns {Array}
 */
// 线性数据转化为树。
export function toTree(data, parent_id = '') {
  var tree = []
  var temp
  for (var i = 0; i < data.length; i++) {
    if (data[i].parent == parent_id || typeof data[i].parent == 'undefined') {
      var obj = JSON.parse(JSON.stringify(data[i]))
      temp = toTree(data, data[i].id)
      if (temp.length > 0) {
        obj.children = temp
      }
      tree.push(obj)
    }
  }
  return tree
}

// 递归删除节点
export function removeNode(nodeList, nodeId) {
  let nodes = JSON.parse(JSON.stringify(nodeList))
  // 删除对应节点
  for (let i in nodeList) {
    if (nodeList[i].id == nodeId) {
      nodeList.splice(i, 1)
    }
  }
  // 删除子节点
  for (let i in nodeList) {
    if (nodeList[i].parent == nodeId) {
      removeNode(nodeList, nodeList[i].id)
    }
  }
  return nodeList
}
